// anti-spy-tools.js
// Script para bloquear herramientas de espionaje para Shopify
// Implementar como archivo separado en assets y cargar en theme.liquid

(function(){
  console.log("Script de protección contra herramientas de espionaje de Shopify iniciado");
  var startTime = Date.now();
  
  // Lista ampliada de dominios de herramientas de espionaje de Shopify
  var dominiosBloqueados = [
    // Herramientas de espionaje de productos
    "ppspy.com",
    "alihunter.io",
    "productlistgenie.io",
    "importyeti.com",
    "spocket.co",
    "oberlo.com",
    "aliexpress.com/dropshipping",
    "dsers.com",
    
    // Herramientas de rastreo de competidores de Shopify
    "shopifyinspector.com",
    "commerceinspector.com",
    "koalainspector.com",
    "shopifyspy.io",
    "myip.ms/shopify",
    "builtwith.com",
    "shopistores.com",
    "shopifycompass.com",
    
    // Herramientas de análisis de mercado
    "nichescraper.com",
    "ecomhunt.com",
    "pexda.com",
    "watchcount.com",
    "bigspy.com",
    "adspy.com",
    "dropshiplooker.com",
    "salesource.io",
    "dropshipfinder.io",
    "pingship.com",
    "foxinsights.io",
    "dropmock.com",
    "pipiads.com",
    "asify.co",
    "dropispy.com",
    "salesource.io",
    "droppoint.site",
    "dropship.io",
    "findniche.com",
    "thieve.co",
    "dropshippiscanner.com",
    "intelligynce.com",
    "adplexity.com",
    "keywordtool.io"
  ];
  
  // Posibles identificadores de extensiones
  var extensionIdentifiers = [
    "ppspy",
    "alihunter",
    "shopifyinspector",
    "koalainspector",
    "commerceinspector",
    "nichescraper",
    "ecomhunt",
    "dropispy",
    "dropship",
    "spocket",
    "oberlo",
    "adspy",
    "bigspy",
    "importyeti",
    "shopify-spy",
    "product-scanner",
    "ds-hunter",
    "ali-orders",
    "drop-spy",
    "ecom-hunt",
    "product-research",
    "winning-product",
    "shopalyst"
  ];
  
  var interval = setInterval(function () {
    // Para depuración
    console.log("Verificando herramientas de espionaje en " + (Date.now() - startTime) + "ms");
    
    // Continuar ejecutando durante más tiempo (2 minutos)
    if (Date.now() - startTime > 120000) {
      console.log("Tiempo de protección finalizado");
      clearInterval(interval);
      return;
    }
    
    var found = false;
    var domainFound = "";
    
    // Buscar enlaces a dominios bloqueados
    dominiosBloqueados.forEach(function(dominio) {
      var elements = document.querySelectorAll('a[href*="' + dominio + '"]');
      if(elements.length > 0){
        console.log("Encontrados enlaces de: " + dominio, elements);
        found = true;
        domainFound = dominio;
        elements.forEach(function(el) {
          el.style.display = "none";
        });
      }
      
      // Buscar iframes que cargan dominios bloqueados
      var iframes = document.querySelectorAll('iframe[src*="' + dominio + '"]');
      if(iframes.length > 0){
        console.log("Encontrados iframes de: " + dominio, iframes);
        found = true;
        domainFound = dominio;
        iframes.forEach(function(el) {
          el.style.display = "none";
        });
      }
      
      // Buscar scripts que cargan dominios bloqueados
      var scripts = document.querySelectorAll('script[src*="' + dominio + '"]');
      if(scripts.length > 0){
        console.log("Encontrados scripts de: " + dominio, scripts);
        found = true;
        domainFound = dominio;
        scripts.forEach(function(el) {
          el.remove(); // Eliminar completamente el script
        });
      }
      
      // Buscar imágenes que cargan desde dominios bloqueados
      var images = document.querySelectorAll('img[src*="' + dominio + '"]');
      if(images.length > 0){
        console.log("Encontradas imágenes de: " + dominio, images);
        found = true;
        domainFound = dominio;
        images.forEach(function(el) {
          el.style.display = "none";
        });
      }
    });
    
    // Detectar posibles elementos de extensiones
    extensionIdentifiers.forEach(function(identifier) {
      // Buscar por ID, clase, atributos de datos o nombre
      var possibleExtElements = document.querySelectorAll(
        '[id*="' + identifier + '"], ' +
        '[class*="' + identifier + '"], ' +
        '[data-extension*="' + identifier + '"], ' +
        '[name*="' + identifier + '"]'
      );
      
      if(possibleExtElements.length > 0){
        console.log("Posibles elementos de la extensión " + identifier, possibleExtElements);
        found = true;
        domainFound = identifier;
        possibleExtElements.forEach(function(el) {
          el.style.display = "none";
        });
      }
    });
    
    // Detectar paneles flotantes o barras de herramientas típicas de extensiones
    var possibleToolbars = document.querySelectorAll(
      'div[style*="position: fixed"][style*="top: 0"], ' +
      'div[style*="position: fixed"][style*="bottom: 0"], ' +
      'div[style*="z-index: 999"], ' +
      'div[style*="z-index: 9999"]'
    );
    
    // Examinar estos elementos para ver si contienen indicadores de herramientas de espionaje
    if(possibleToolbars.length > 0) {
      possibleToolbars.forEach(function(toolbar) {
        extensionIdentifiers.forEach(function(identifier) {
          if(toolbar.innerHTML.toLowerCase().includes(identifier)) {
            console.log("Barra de herramientas de extensión detectada: " + identifier, toolbar);
            found = true;
            domainFound = identifier;
            toolbar.style.display = "none";
          }
        });
      });
    }
    
    // Si se encontró alguno de los elementos
    if(found){
      console.log("Herramienta de espionaje detectada: " + domainFound + ", bloqueando componentes");
      alert("Herramienta de espionaje bloqueada: " + domainFound + " - Protegido por @aparicio7w7");
      
      // Solo redirige si estamos en el propio sitio de alguna herramienta de espionaje
      var currentUrl = window.location.href.toLowerCase();
      var shouldRedirect = false;
      
      dominiosBloqueados.forEach(function(dominio) {
        if(currentUrl.includes(dominio)) {
          shouldRedirect = true;
        }
      });
      
      if(shouldRedirect) {
        window.location.href = "/";
      }
    }
    
    // Función para limpiar elementos sospechosos insertados dinámicamente
    function limpiarElementosInsertados() {
      var allElements = document.querySelectorAll('*');
      allElements.forEach(function(element) {
        var elementHTML = element.outerHTML.toLowerCase();
        extensionIdentifiers.forEach(function(identifier) {
          if(elementHTML.includes(identifier)) {
            console.log("Elemento sospechoso encontrado y eliminado", element);
            element.style.display = "none";
          }
        });
      });
    }
    
    // Ejecutar limpieza periódicamente
    setTimeout(limpiarElementosInsertados, 1500);
  }, 1000);
  
  // Detectar y bloquear solicitudes de red a dominios bloqueados
  if(window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function(url, options) {
      var blockedRequest = false;
      dominiosBloqueados.forEach(function(dominio) {
        if(url.toString().includes(dominio)) {
          console.log("Solicitud fetch bloqueada a: " + url);
          blockedRequest = true;
        }
      });
      
      if(blockedRequest) {
        // Devolver una promesa rechazada para simular error de red
        return Promise.reject(new Error("Solicitud bloqueada por el script de protección"));
      }
      
      return originalFetch.apply(this, arguments);
    };
  }
  
  // Interceptar XMLHttpRequest
  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    var blockedRequest = false;
    dominiosBloqueados.forEach(function(dominio) {
      if(url.toString().includes(dominio)) {
        console.log("Solicitud XMLHttpRequest bloqueada a: " + url);
        blockedRequest = true;
      }
    });
    
    if(blockedRequest) {
      // No hacer nada para bloquear la solicitud
      this.abort();
      return;
    }
    
    return originalOpen.apply(this, arguments);
  };
  
  console.log("Protección contra herramientas de espionaje activada completamente");
})();